/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberAssetsPagedOutputDto { 
    id?: number;
    memberAssetType?: string | null;
    assetValue?: string | null;
    location?: string | null;
    comments?: string | null;
    uploadDate?: string;
    fileType?: string | null;
    documentId?: string;
}

